module.exports = __webpack_public_path__ + "r-v3/img/cam_off_red.2b15ffd1.svg";